import React from 'react';
import PropTypes from 'prop-types';
import Charts from './Charts';
import { renderTooltip } from '../../../util/QuickReportsUtils';

const PieChart = ({
  chartTitle = '',
  chartColor = [
    '#247BA0',
    '#F25F5C',
    '#FFE066',
    '#4ECDC4',
    '#008490',
    '#F67451',
    '#E1D2A5',
    '#94D3DC',
    '#5CA4A9',
    '#FAB266',
  ],
  pieChartHeight = null,
  pieChartWidth = null,
  showLegend = true,
  chartLegend = {
    align: 'center',
    verticalAlign: 'top',
    layout: 'vertical',
    x: 0,
    y: 0,
    itemStyle: {
      color: 'RGB(48, 67, 93)',
      fontSize: '12px',
      lineHeight: '32px',
      fontWeight: 'normal',
    },
  },
  donutSize = '0',
  alignTitle = 'top',
  dataLabelFormat = '{point.percentage:.1f} %',
  dataLabelDistance = -30,
  dataLabelColor = '#fff',
  titleColor = '#30435d',
  titleHorizontalAlign = 'center',
  data,
}) => {
  const config = {
    chart: {
      type: 'pie',
      height: pieChartHeight,
      width: pieChartWidth,
      marginTop: 30,
      style: {
        fontFamily: 'Open Sans, sans-serif',
      },
    },
    title: {
      verticalAlign: alignTitle,
      align: titleHorizontalAlign,
      text: chartTitle,
      margin: 5,
      width: 1,
      height: 5,
      y: 0,
      
      style: {
        fontSize: '18px',
        color: titleColor,
      },
    },
    legend: chartLegend,
    plotOptions: {
      pie: {
        innerSize: donutSize,
        colors: chartColor,
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          useHTML: true,
          enabled: true,
          format: dataLabelFormat,
          distance: dataLabelDistance,
          color: dataLabelColor,
        },
        showInLegend: showLegend,
      },
    },
    tooltip: {
      useHTML: true,
      headerFormat: '<b><span>{point.key}</span></b><br />',
      pointFormat: renderTooltip(data.tooltip),
      backgroundColor: '#fff',
      padding: '0',
      borderColor: 'RGB(71, 100, 138)',
      borderRadius: 6,
    },
    series: [
      {
        name: chartTitle,
        keys: [],
        colorByPoint: true,
        data: data.processedData,
      },
    ],
  };
  return <Charts config={config} />;
};

PieChart.propTypes = {
  chartTitle: PropTypes.string,
  data: PropTypes.shape({}),
  showLegend: PropTypes.bool,
  chartLegend: PropTypes.shape({}),
  chartColor: PropTypes.arrayOf(PropTypes.string),
  pieChartHeight: PropTypes.number,
  pieChartWidth: PropTypes.number,
  donutSize: PropTypes.string,
  alignTitle: PropTypes.string,
  dataLabelFormat: PropTypes.string,
  dataLabelDistance: PropTypes.number,
  dataLabelColor: PropTypes.string,
  titleHorizontalAlign: PropTypes.string,
  titleColor: PropTypes.string,
};

export default PieChart;
